import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePassword } from "../../services/userService";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {toast } from 'react-toastify';
import Loader from "../Loader";

const EditPassword = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isValid },
  } = useForm({mode: "onChange"});
  const newPassword = watch("newPassword");

  const dispatch = useDispatch();
  const {
    errors: errosForm,
    loader,
    isSuccess,
  } = useSelector((state) => state.user);

  const onSubmit = (data) => {
    dispatch(changePassword(data));
    reset();
  };
  if (loader) return <Loader />
  return (
    <>
       {isSuccess && 
        toast.success(t('form.password.success'), {
          position: toast.TOP_RIGHT,
        })
    }  
      {errosForm?.length > 0 && (
        <div className="flex justify-between py-4 px-8 bg-[#fad2e1]  text-[#7c193d]">
          <ul>
            {errosForm?.map((error, key) => (
              <li key={key} className="font-medium">
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="flex">
        <div className="w-full max-w-md p-8 space-y-6">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-600">
                {t("login.form.password.oldPassword")} *
              </label>
              <input
                type="password"
                {...register("oldPassword", {
                  required: t("form.required"),
                })}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              />
              {errors.oldPassword && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.oldPassword.message}
                </p>
              )}
            </div>
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-600">
                {t("login.form.password.newPassword")} *
              </label>
              <input
                type="password"
                {...register("newPassword", {
                  required: t("form.required"),
                  minLength: {
                    value: 4,
                    message: t("register.form.password.message"),
                  },
                  validate: {
                    hasUppercase: (value) =>
                      /[A-Z]/.test(value) ||
                      t("register.form.password.upperLetter"),
                    hasNumber: (value) =>
                      /[0-9]/.test(value) || t("register.form.password.number"),
                  },
                })}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              />
              {errors.newPassword && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.newPassword.message}
                </p>
              )}
            </div>
            <div>
              <label className="block text-gray-700 text-sm font-medium mb-2">
                {t("register.form.password.labelConfirm")} *
              </label>

              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
                type="password"
                {...register("confirmPassword", {
                  required: t("form.required"),
                  validate: {
                    hasUppercase: (value) =>
                      /[A-Z]/.test(value) ||
                      t("register.form.password.upperLetter"),
                    hasNumber: (value) =>
                      /[0-9]/.test(value) || t("register.form.password.number"),
                    matchesPassword: (value) =>
                      value === newPassword || "Passwords do not match",
                  },
                })}
              />
              {errors.confirmPassword && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.confirmPassword.message}
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={!isValid}
              className="w-full px-4 py-2 font-medium text-white bg-primaryColor rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
            >
              {t("login.form.button")}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditPassword;
